module.exports = __webpack_public_path__ + "static/img/Dean-Pay.491fda4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dean-Pay.jpg
// module id = qw09
// module chunks = 0